interface ModuleStubProps {
  title: string;
  description?: string;
}

export const ModuleStub = ({ title, description }: ModuleStubProps) => (
  <section className="flex-1 flex flex-col items-center justify-center px-8 py-16">
    <div className="max-w-md text-center flex flex-col gap-3">
      <p className="font-mono text-xs uppercase tracking-[0.08em] text-extranet-text-tertiary">Bientôt disponible</p>
      <h2 className="text-2xl font-semibold tracking-tight text-extranet-text-primary">{title}</h2>
      <p className="text-extranet-text-secondary text-sm leading-relaxed">
        {description ?? 'Ce module sera ajouté dans une prochaine itération du portail extranet.'}
      </p>
    </div>
  </section>
);
